import { FC } from 'react';
import EActivitiesElementSkeleton from '@/components/everridge/activities/EActivitiesElementSkeleton';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

type Props = {
	count?: number;
	isMobile?: boolean;
};

const EActivitiesListSkeleton: FC<Props> = ({ count = 5, isMobile }) => {
	return (
		<div className={cn('-mx-6', isMobile && '-mx-4')}>
			<Skeleton
				className={cn(
					'h-3 w-16 my-1 mx-6 rounded-full',
					isMobile && 'mx-4',
				)}
			/>
			<div>
				{Array.from({ length: count }, (_, index) => (
					<EActivitiesElementSkeleton
						key={index}
						isMobile={isMobile}
					/>
				))}
			</div>
		</div>
	);
};

export default EActivitiesListSkeleton;
